import React from 'react';
import { Stack } from '@antonpodolsky/design-system/layout/stack/stack';
import { Rating } from '@antonpodolsky/design-system/data-display/rating/rating';
import { AddonButton } from './addon-button';
import { Browser } from './addon-browsers';
import { useAddonRating } from './use-addon-rating';

interface Props {
  browser: Browser;
}

export const AddonButtonWithRating = ({ browser }: Props) => {
  const rating = useAddonRating(browser);

  return (
    <Stack gap="sm" align="start">
      <AddonButton browser={browser} />
      <Rating value={rating} />
    </Stack>
  );
};
